"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getRecsSessionValue = () => {
    const sessionStorageName = 'recs-product';
    const sessionStorageVal = sessionStorage.getItem(sessionStorageName);
    if (sessionStorageVal) {
        const recsDataLayerObject = {
            recommendations: {
                sessionStorageName: sessionStorageVal,
            },
        };
        if (window.mergeIntoDataLayer) {
            window.mergeIntoDataLayer(recsDataLayerObject);
        }
        sessionStorage.removeItem(sessionStorageName);
    }
};
exports.default = getRecsSessionValue;
